// extracted by mini-css-extract-plugin
export default {"rosterPage":"RosterPage_rosterPage__PbYYG","courseHeader":"RosterPage_courseHeader__vSyO2","content":"RosterPage_content__mdiIa","rosterBlock":"RosterPage_rosterBlock__vn5KT"};